import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth.js'
import { isValidLocale, detectInitialLocale, setLocale } from '@/i18n/index.js'

const routes = [
  {
    // Root → redirect to the best locale (route param is the source of truth
    // once present; otherwise detect from stored choice / browser language).
    path: '/',
    redirect: () => `/${detectInitialLocale()}`
  },
  {
    // Localised landing page, e.g. /en-en or /nl-nl
    path: '/:locale([a-z]{2}-[a-z]{2})',
    component: () => import('@/views/LandingView.vue'),
    meta: { public: true }
  },
  {
    path: '/login',
    component: () => import('@/views/LoginView.vue'),
    meta: { public: true }
  },  
  {
    path: '/register',
    component: () => import('@/views/RegisterView.vue'),
    meta: { public: true }
  },
  {
    path: '/dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { requiresAuth: true }
  },
  {
    // MUST come before '/dashboard/:siteId' or that route swallows it
    path: '/dashboard/profile',
    component: () => import('@/views/ProfileView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard/:siteId',
    component: () => import('@/views/SiteDetailView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard/:siteId/subdomains/:subId',
    component: () => import('@/views/SiteDetailView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, saved) {
    if (saved) return saved
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  }
})

router.beforeEach((to) => {
  // Locale route is the source of truth: validate it and activate it.
  if (to.params && to.params.locale !== undefined) {
    if (!isValidLocale(to.params.locale)) {
      return { path: `/${detectInitialLocale()}` }
    }
    setLocale(to.params.locale)
  }

  const auth = useAuthStore()
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }
  if (to.path === '/login' && auth.isAuthenticated) {
    return { path: '/dashboard' }
  }
})

export default router